"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");
/**
 * @param {boolean} condition - Condition if true adds handler to event
 * @param element - Reference to element to watch for outside click
 * @param handler- Single function you wish to run on outside click
 */


var useOutsideClick = function useOutsideClick(_ref) {
  var condition = _ref.condition,
      element = _ref.element,
      handler = _ref.handler;
  (0, _react.useEffect)(function () {
    var listener = function listener(event) {
      if (element.current && !element.current.contains(event.target)) {
        handler(event);
      }
    };

    if (condition) {
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return function () {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    }
  }, [condition, element, handler]);
};

var _default = useOutsideClick;
exports["default"] = _default;